import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots } from "vue";
import global from '@/component-create/utils/global';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import { log } from '@/component-create/utils/log';
import { chineseToPinYin } from '@/component-create/utils/common';
import EventBus from '@/utils/event-bus';

import { toRefs, ref, computed, reactive, watch, onMounted, onUnmounted } from 'vue';
const DICT_CACHE_KEY_PREFIX = 'x-select:dict:';
const LOADER_CACHE_KEY_PREFIX = 'x-select:loader:';
const DEFAULT_LABEL_KEY = 'label';
const DEFAULT_VALUE_KEY = 'value';
const DEFAULT_DICT_LABEL_KEY = 'dataName';
const DEFAULT_DICT_VALUE_KEY = 'dataValue';
const EVENT_INPUT = 'update:modelValue';
const EVENT_PREPARED = 'prepared';
const TYPE_OPTIONS = 'options';
const TYPE_DICT = 'dict';
const TYPE_LOADER = 'loader';
const SELECT_EVENT = 'selected';
/**
 * 字典数据状态
 *
 */
var DICTIONARY_DATA_STATUS;
(function (DICTIONARY_DATA_STATUS) {
  /**
   * 启用
   */
  DICTIONARY_DATA_STATUS["ENABLED"] = "1";
  /**
   * 禁用
   */
  DICTIONARY_DATA_STATUS["DISABLED"] = "0";
})(DICTIONARY_DATA_STATUS || (DICTIONARY_DATA_STATUS = {}));
// eslint-disable-next-line vue/valid-define-emits
export default /*@__PURE__*/_defineComponent({
  __name: 'XSelect',
  props: {
    modelValue: {},
    options: {},
    dictCode: {},
    loader: {},
    labelKey: {
      default: 'label'
    },
    valueKey: {
      default: 'value'
    },
    loaderParam: {},
    allOption: {
      type: Boolean,
      default: false
    },
    allLabel: {
      default: '全部'
    },
    allValue: {
      default: ''
    },
    default: {
      type: [Boolean, Number, String]
    },
    defaultOnNull: {
      type: Boolean,
      default: false
    },
    resetOnReload: {
      default: 'always'
    },
    cache: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    disableOption: {
      type: Function,
      default: () => false
    },
    on: {},
    emit: {},
    elProps: {},
    smartSearch: {
      type: Boolean
    }
  },
  emits: ['update:modelValue', 'selected', 'prepared'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const prop = __props;
    let LOADERS = global.globalVal[GLOBAL_DATA.LOADERS];
    let REQUEST = global.globalVal[GLOBAL_DATA.SELECT_REQUEST];
    global.subscribe('LOADERS', value => {
      LOADERS = value;
    });
    const {
      modelValue,
      disableOption,
      elProps,
      smartSearch
    } = toRefs(prop);
    // 加载时默认选项值
    const loadingSelect = ref('');
    const selectOptions = ref([]);
    const enableCache = ref(false);
    const loaderIsUpdated = ref(true);
    const realFilter = computed(() => {
      if (prop.smartSearch) {
        return smartFilter;
      } else {
        return undefined;
      }
    });
    const loaderConfig = reactive({
      loaderParam: prop.loaderParam
    });
    const select = reactive({
      type: '',
      loading: false,
      labelKey: '',
      valueKey: '',
      resetValue: false,
      sourceOptions: []
    });
    const EXECUTOR = reactive({
      lazy: false,
      runnable: null,
      execute(runnable) {
        if (!prop.lazy) {
          runnable();
          return;
        }
        this.runnable = runnable;
      },
      run() {
        if (this.runnable) {
          this.runnable();
        }
      }
    });
    const value = computed({
      get() {
        if (select.loading) {
          return loadingSelect.value;
        }
        return modelValue.value;
      },
      set(v) {
        emit(EVENT_INPUT, v);
        emit(SELECT_EVENT, v);
      }
    });
    watch(modelValue, val => {
      customEventEmit(val);
    }, {
      immediate: true
    });
    if (prop.on) {
      EventBus.on(prop.on, val => {
        loaderConfig.loaderParam = val;
        select.resetValue = true;
        lazyPerformRequest();
      });
    }
    init();
    if (prop.options) {
      initByOptions();
      select.type = TYPE_OPTIONS;
    } else if (prop.dictCode) {
      initByDictCode();
      select.type = TYPE_DICT;
    } else if (prop.loader) {
      initByLoader();
      select.type = TYPE_LOADER;
    }
    onMounted(() => {
      if (select.type === TYPE_LOADER) {
        if (!isCascadedSelect()) {
          lazyPerformRequest();
        }
      }
      if (modelValue.value) {
        customEventEmit(modelValue.value);
      }
    });
    onUnmounted(() => {
      if (prop.on) {
        EventBus.off(prop.on);
      }
    });
    function smartFilter(value) {
      if (!value) {
        selectOptions.value = select.sourceOptions;
      } else {
        selectOptions.value = select.sourceOptions.filter(item => {
          return chineseToPinYin(item[select.labelKey]).replace(/[a-z]/g, '').includes(value.toUpperCase()) || item[select.labelKey].toUpperCase().includes(value.toUpperCase());
        });
      }
    }
    function customEventEmit(val) {
      if (prop.emit) {
        EventBus.emit(prop.emit, val);
      }
    }
    function init() {
      EXECUTOR.lazy = prop.lazy;
      select.labelKey = prop.labelKey;
      select.valueKey = prop.valueKey;
      enableCache.value = prop.cache;
      loaderConfig.loaderParam = prop.loaderParam;
    }
    function initByOptions() {
      setOptions(prop.options || []);
      watch(() => prop.options, v => {
        setOptions(v || []);
      });
    }
    function initByDictCode() {
      if (isDefaultLabelKey()) {
        select.labelKey = DEFAULT_DICT_LABEL_KEY;
      }
      if (isDefaultValueKey()) {
        select.valueKey = DEFAULT_DICT_VALUE_KEY;
      }
      EXECUTOR.execute(() => {
        performDictLoading();
      });
    }
    function performDictLoading() {
      if (enableCache.value) {
        const cache = getDictCache();
        if (cache && cache.length > 0) {
          setOptions(cache);
          return;
        }
      }
      startLoading();
      if (!REQUEST) {
        log('XSelect', `未配置选择器加载请求服务：${GLOBAL_DATA.SELECT_REQUEST}`, 'error');
        return;
      }
      REQUEST(prop.dictCode).then(result => {
        const data = result.data;
        if (data && data.length > 0) {
          const filtered = data.filter(d => d.status !== DICTIONARY_DATA_STATUS.DISABLED);
          setOptions(filtered);
          setDictCache(filtered);
        } else {
          log('XSelect', `未获取到该字典信息：${prop.dictCode}`, 'error');
        }
      }).finally(() => {
        stopLoading();
      });
    }
    function initByLoader() {
      const loader = getLoader();
      if (!loader) {
        log('XSelect', `该加载器未定义：${prop.loader}`, 'error');
        return [];
      }
      if (isDefaultLabelKey() && loader.labelKey) {
        select.labelKey = loader.labelKey;
      }
      if (isDefaultValueKey() && loader.valueKey) {
        select.valueKey = loader.valueKey;
      }
      if (isCascadedSelect()) {
        enableCache.value = false;
      }
      if (isLoaderParamSpecified()) {
        watchLoaderParam();
      }
    }
    function watchLoaderParam() {
      // 如果指定了loader-param则关闭缓存
      enableCache.value = false;
      watch(() => prop.loaderParam, val => {
        clearOptions();
        select.resetValue = true;
        loaderConfig.loaderParam = val;
        if (!isCascadedSelect()) {
          lazyPerformRequest();
        }
      }, {
        immediate: true
      });
    }
    function lazyPerformRequest() {
      EXECUTOR.execute(() => performRequest());
    }
    function performRequest() {
      if (enableCache.value) {
        const cache = getLoaderCache();
        if (cache && cache.length > 0) {
          setOptions(cache);
          return;
        }
      }
      // 减少请求次数
      if (select.loading) {
        loaderIsUpdated.value = false;
        return;
      }
      const request = {
        loaderParam: loaderConfig.loaderParam
      };
      const result = getLoader?.()?.request(request);
      if (result && result instanceof Promise) {
        startLoading();
        result.then(options => {
          setOptions(options);
          setLoaderCache(options);
        }).catch(error => {
          clearOptions();
          log('XSelect', error, 'error');
        }).finally(() => {
          stopLoading();
          if (!loaderIsUpdated.value) {
            loaderIsUpdated.value = true;
            performRequest();
          }
        });
      }
    }
    function setOptions(options) {
      selectOptions.value = [];
      if (options && options.length > 0) {
        selectOptions.value.push(...options);
      }
      if (prop.smartSearch) {
        select.sourceOptions = selectOptions.value;
      }
      doOnOptionsPrepared();
    }
    function clearOptions() {
      selectOptions.value = [];
    }
    function prependAllOption() {
      if (prop.allOption && getOptionsCount() > 0) {
        const option = {};
        option[select.labelKey] = prop.allLabel;
        option[select.valueKey] = prop.allValue;
        prependOptions(option);
      }
    }
    function doOnOptionsPrepared() {
      prependAllOption();
      emit(EVENT_PREPARED, getOptions);
      if (select.resetValue) {
        const policy = prop.resetOnReload;
        let reset = false;
        if (policy === 'always') {
          reset = true;
        } else if (policy === 'miss') {
          reset = true;
          const options = getOptions();
          if (options && options.length > 0) {
            for (const option of options) {
              if (getOptionValue(option) === getSelectedValue()) {
                reset = false;
                break;
              }
            }
          }
        }
        if (reset) {
          clearSelectedValue();
        }
        select.resetValue = false;
      }
      if (isDefaultSelectNeeded()) {
        const defaultOp = getDefaultOption();
        if (defaultOp) {
          setSelectedOption(defaultOp);
        }
      }
    }
    /**
     * 获取所有选项
     */
    function getOptions() {
      return selectOptions.value;
    }
    /**
     * 获取选项数量
     */
    function getOptionsCount() {
      return getOptions() ? getOptions().length : 0;
    }
    /**
     * 在开头追加选项
     */
    function prependOptions(...options) {
      const currentOptions = getOptions();
      currentOptions.unshift(...options);
    }
    /**
     * 在结尾追加选项
     */
    function appendOptions(...options) {
      const currentOptions = getOptions();
      currentOptions.push(...options);
    }
    function getDefaultOption() {
      const options = getOptions();
      if (!options || options.length === 0) {
        return;
      }
      if (prop.default == null || !options || options.length < 1) {
        return;
      }
      if (prop.default === true) {
        return options[0];
      }
      if (typeof prop.default === 'number') {
        return options[prop.default];
      }
      if (prop.default === 'last') {
        return options[options.length - 1];
      }
      if (prop.default === 'first') {
        return options[0];
      }
    }
    function isDefaultSelectNeeded() {
      return !!prop.default;
    }
    function resetToDefault() {
      const option = getDefaultOption();
      if (option) {
        setSelectedOption(option);
      } else {
        log('XSelect', '重置为默认选项失败，没有匹配的默认选项', 'warning');
      }
    }
    function getSelectedValue() {
      return modelValue.value;
    }
    /**
     * 获取当前选中的对象
     *
     * @returns {null|*} 选中的对象:select.options
     */
    function getSelectedOption() {
      const options = getOptions();
      if (!options || options.length === 0) {
        return null;
      }
      return options.find(option => {
        return getOptionValue(option) === getSelectedValue();
      });
    }
    function setSelectedValue(value) {
      emit(EVENT_INPUT, value);
      emit(SELECT_EVENT, value);
    }
    function clearSelectedValue() {
      setSelectedValue(null);
    }
    function setSelectedOption(option) {
      setSelectedValue(getOptionValue(option));
    }
    function isDefaultLabelKey() {
      return select.labelKey === DEFAULT_LABEL_KEY;
    }
    function getOptionLabel(option) {
      return option[select.labelKey];
    }
    function isDefaultValueKey() {
      return select.valueKey === DEFAULT_VALUE_KEY;
    }
    function getOptionValue(option) {
      return option[select.valueKey];
    }
    function setDictCache(options) {
      setOptionsCache(`${DICT_CACHE_KEY_PREFIX}${prop.dictCode}`, options);
    }
    function setLoaderCache(options) {
      setOptionsCache(`${LOADER_CACHE_KEY_PREFIX}${prop.loader}`, options);
    }
    function setOptionsCache(key, options) {
      if (enableCache.value && options && options.length > 0) {
        localStorage.setItem(key, JSON.stringify(options));
      }
    }
    function getDictCache() {
      return JSON.parse(localStorage.getItem(`${DICT_CACHE_KEY_PREFIX}${prop.dictCode}`) || '[]');
    }
    function getLoaderCache() {
      return JSON.parse(localStorage.getItem(`${LOADER_CACHE_KEY_PREFIX}${prop.loader}`) || '[]');
    }
    function handleFocus() {
      // 执行懒加载
      EXECUTOR.run();
    }
    function startLoading() {
      select.loading = true;
    }
    function stopLoading() {
      select.loading = false;
    }
    function getLoader() {
      if (!prop.loader) {
        return null;
      }
      if (!LOADERS) {
        log('XSelect', '加载失败，未配置加载器：' + GLOBAL_DATA.LOADERS, 'error');
        return null;
      }
      return LOADERS[prop.loader];
    }
    function isLoaderParamSpecified() {
      return prop.loaderParam !== undefined;
    }
    /**
     * 是否存在联动的下拉框
     *
     * @return {boolean} true-存在 false-不存在
     */
    function isCascadedSelect() {
      return prop.on !== null && prop.on !== undefined;
    }
    __expose({
      getSelectedOption,
      resetToDefault,
      appendOptions
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_component_el_select, _mergeProps({
        ref: "selectRef",
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(value) ? value.value = $event : null),
        "filter-method": _unref(realFilter),
        filterable: _unref(smartSearch)
      }, _unref(elProps) || {}, {
        loading: _unref(select).loading
      }, _toHandlers(_ctx.$attrs), {
        onFocus: handleFocus
      }), _createSlots({
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOptions), (option, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `${getOptionLabel(option)}-${getOptionValue(option)}`,
            label: getOptionLabel(option),
            value: getOptionValue(option),
            disabled: _unref(disableOption)(index, getOptionLabel(option), getOptionValue(option), option)
          }, null, 8, ["label", "value", "disabled"]);
        }), 128))]),
        _: 2
      }, [_ctx.$slots.prefix ? {
        name: "prefix",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "prefix")]),
        key: "0"
      } : undefined, _ctx.$slots.empty ? {
        name: "empty",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "empty")]),
        key: "1"
      } : undefined]), 1040, ["modelValue", "filter-method", "filterable", "loading"]);
    };
  }
});